import { all, call, fork, put, takeLatest } from "redux-saga/effects"
import { getSearchResultsApi } from "../../services/Api/SearchApi"
import { getErrors, getSearchResultsSuccess } from "../reducers/SearchResultsReducer"

// Watchers
function* searchResultsSaga() {
	yield takeLatest("search_results/getSearchResults", fetchSearchResults)
}

// Sagas
function* fetchSearchResults(action) {
	try {
		const response = yield call(getSearchResultsApi, action.payload)

		if (response.request.status === 200) {
			yield put(getSearchResultsSuccess(response))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(searchResultsSaga)])
}
